import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from '@emotion/styled';
import { Row } from '../../../../../../ui';
import { ISelectCardFormData } from '../types/ISelectCardFormData';
import { useDeleteTokenizedCard } from '../helpers/useDeleteTokenizedCard';
import { TokenizedCardSelector } from '../../../../../payment/ui/credit-card/selector';
import { ITokenizedCard } from '../../../../../payment/domain/models';

interface ISelectCardOptionsProps {
	cards: ITokenizedCard[];
}

export const SelectCardOptions = ({ cards }: ISelectCardOptionsProps) => (
	<StyledSelectCardOptions>
		{cards.map((card) => (
			<SelectCardOption key={card.id} card={card} />
		))}
	</StyledSelectCardOptions>
);

const StyledSelectCardOptions = styled(Row)`
	margin-top: 0;
`;

interface ISelectCardOptionProps {
	card: ITokenizedCard;
}

const SelectCardOption = ({ card }: ISelectCardOptionProps) => {
	const { register } = useFormContext<ISelectCardFormData>();
	const { deleteTokenizedCard, isDeleting } = useDeleteTokenizedCard(card.id);

	return (
		<TokenizedCardSelector
			key={card.id}
			card={card}
			canBeDeleted={!isDeleting}
			disabled={isDeleting}
			onClickDelete={deleteTokenizedCard}
			{...register('tokenizedCardId')}
		/>
	);
};
